/* printSettingsFileSection.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const printSettingsFileSectionComponent = {
  template: require('./printSettingsFileSection.html'),
  controllerAs: 'vm',
  controller: class printSettingsFileSectionController {
    /* @ngInject */
    constructor(sessionDataService, commonService, $state) {
      this.sessionDataService = sessionDataService
      this.commonService = commonService
      this.$state = $state
    }
    $onInit() {
      this.screenSize = this.commonService.getScreenSize()
      this.quantity = this.sessionDataService.selectedFiles.length
      if (this.quantity == 1)
        this.singleFilename = this.sessionDataService.selectedFiles[0].DisplayName
    }
    changeDestination() {
      this.sessionDataService.lastOp = 'printSettings'
      this.$state.go('print')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/print/components/printSettingsFileSection.component.js